// Threshold-to-label mapping (sorted highest to lowest for easy iteration)
export const GAUGE_STATUS_CONFIG = [
  { threshold: 80, label: 'On Fire! 🔥' },
  { threshold: 65, label: 'Excellent!' },
  { threshold: 50, label: 'Good!' },
] as const;

export const GAUGE_POSITIONING = {
  TOP_WITH_STATUS: 110,
  TOP_WITHOUT_STATUS: 135,
} as const;

export const GAUGE_TYPOGRAPHY = {
  STATUS_FONT_SIZE: 16,
  VALUE_FONT_SIZE: 18,
  LABEL_FONT_SIZE: 12,
  STATUS_FONT_WEIGHT: 600,
  VALUE_FONT_WEIGHT: 600,
  LABEL_FONT_WEIGHT: 400,
} as const;

export const GAUGE_SPACING = {
  CONTAINER_GAP: 2,
  ITEM_SPACING: 0.5,
  ITEM_SPACING_WITH_LABEL: 1,
  BORDER_RADIUS: 6,
  PADDING_VERTICAL: 1.5,
  PADDING_HORIZONTAL: 3,
} as const;
